<section *ngIf="highlightsProperties && highlightsProperties.length > 0"
  class="featured portfolio rec-pro disc py-5 popular-desktop">
  <div class="container-fluid">
    <div class="sec-title discover">
      <h2><span>{{"HOME.HIGHLIGHTS.TEXT" | translate}}</span></h2>
    </div>
    <div class="portfolio pb-5 col-xl-12 position-relative overflow-hidden"
      style="padding-left: 0px; padding-right: 0px;">
      <div #propertiesCards [style.width]="(highlightsProperties.length * 25) + '%'" class="properties-cards">
        <div id="property-card-{{i}}" *ngFor="let property of highlightsProperties; let i = index"
          class="agents-grid property-card">
          <div class="landscapes">
            <div class="project-single">
              <a [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
                class="homes-img">
                <div class="project-inner project-head">
                  <div class="homes">
                    <!-- homes img -->
                    <div class="homes-tag button alt featured">{{'PROPERTY-FEATURED.TEXT' |
                      translate}}</div>
                    <div *ngIf="property?.cardToShow" class="homes-tag button alt sale">{{property?.cardToShow}}
                    </div>
                    <img [src]="property.media[0].file" alt="Property Image" class="img-responsive fit-cover">
                  </div>
                </div>
              </a>
              <!-- homes content -->
              <div class="homes-content">
                <!-- homes address -->
                <h3><a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.title}}</a>
                </h3>
                <p *ngIf="property.district && property.district != ''" class="homes-address mb-3">
                  <a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                    <i class="fa fa-map-marker"></i><span
                      *ngIf="property.county && property.county != ''">{{property.county}},
                    </span><span>{{property.district}}</span>
                  </a>
                </p>
                <p *ngIf="(!property.district || property.district == '') && property.region"
                  class="homes-address mb-3">
                  <a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                    <i class="fa fa-map-marker"></i><span
                      *ngIf="property.country && property.country != ''">{{property.country}},
                    </span><span>{{property.region}}</span>
                  </a>
                </p>
                <!-- homes List -->
                <div class="price-properties footer pt-3 pb-0">
                  <h3 class="title mt-3">
                    <a
                      [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.price
                      != 0 && property.price != null ? priceFormat(property.price, property.currency) :
                      't-on-request' | translate}}</a>
                  </h3>
                  <div class="compare">
                    <a (click)="utilsPropertiesService.shareProperty(property)">
                      <i class="flaticon-share"></i>
                    </a>
                    <a (click)="saveProperty(property.uniqueId)">
                      <ion-icon *ngIf="!savedService.isSavedProperty(property.uniqueId)"
                        name="heart-outline"></ion-icon>
                      <ion-icon *ngIf="savedService.isSavedProperty(property.uniqueId)"
                        class="heart-icon colored-heart-icon" name="heart"></ion-icon>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="properties-card-dots">
        <ng-container *ngFor="let property of highlightsProperties; let i = index;">
          <li [ngClass]="{'active':activeDot === i}" (click)="changeDots(i, propertiesCards)" class="prop-card-dot"
            *ngIf="i === 0 || i > 3"></li>
        </ng-container>
      </ul>
    </div>
  </div>
</section>
<!-- END SECTION RECENTLY PROPERTIES -->

<section *ngIf="localAccommodations && localAccommodations.length > 0"
  class="featured portfolio rec-pro disc py-5 popular-desktop">
  <div class="container-fluid">
    <div class="sec-title discover">
      <h2><span>{{"t-local-accommodations" | translate}}</span></h2>
    </div>
    <div class="portfolio pb-5 col-xl-12 position-relative overflow-hidden"
      style="padding-left: 0px; padding-right: 0px;">
      <div #propertiesCardsLocal [style.width]="(localAccommodations.length * 25) + '%'"
        [ngClass]="{'justify-content-center': localAccommodations.length > 1 && localAccommodations.length < 4}"
        class="properties-cards">
        <div id="property-local-card-{{i}}" *ngFor="let property of localAccommodations; let i = index"
          class="agents-grid property-card">
          <div class="landscapes">
            <div class="project-single">
              <a [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
                class="homes-img">
                <div class="project-inner project-head">
                  <div class="homes">
                    <!-- homes img -->
                    <div class="homes-tag button alt featured">{{'PROPERTY-FEATURED.TEXT' |
                      translate}}</div>
                    <div *ngIf="property?.cardToShow" class="homes-tag button alt sale">{{property?.cardToShow}}
                    </div>
                    <img [src]="property.media[0].file" alt="Property Image" class="img-responsive fit-cover">
                  </div>
                </div>
              </a>
              <!-- homes content -->
              <div class="homes-content">
                <!-- homes address -->
                <h3><a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.title}}</a>
                </h3>
                <p *ngIf="property.district && property.district != ''" class="homes-address mb-3">
                  <a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                    <i class="fa fa-map-marker"></i><span
                      *ngIf="property.county && property.county != ''">{{property.county}},
                    </span><span>{{property.district}}</span>
                  </a>
                </p>
                <!-- homes List -->
                <div class="price-properties footer pt-3 pb-0">
                  <h3 class="title mt-3">
                    <a
                      [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.price
                      != 0 && property.price != null ? priceFormat(property.price, property.currency) :
                      't-on-request' | translate}}</a>
                  </h3>
                  <div class="compare">
                    <a (click)="utilsPropertiesService.shareProperty(property)">
                      <i class="flaticon-share"></i>
                    </a>
                    <a (click)="saveProperty(property.uniqueId)">
                      <ion-icon *ngIf="!savedService.isSavedProperty(property.uniqueId)"
                        name="heart-outline"></ion-icon>
                      <ion-icon *ngIf="savedService.isSavedProperty(property.uniqueId)"
                        class="heart-icon colored-heart-icon" name="heart"></ion-icon>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="properties-card-dots">
        <ng-container *ngFor="let property of localAccommodations; let i = index;">
          <li [ngClass]="{'active':activeDot === i}" (click)="changeDotsLocal(i, propertiesCardsLocal)"
            class="prop-card-dot" *ngIf="i === 0 || i > 3"></li>
        </ng-container>
      </ul>
    </div>
  </div>
</section>
<!-- END SECTION RECENTLY PROPERTIES -->
